// extracted by mini-css-extract-plugin
module.exports = {"my-story":"my-story_my-story__DD6WO","content":"my-story_content__1Uoql"};